// src/domains/filters/filters.api.ts

import { API_ENDPOINTS, getFullEndpoint } from '@/services/api/endpoints';
import { useApiMutation } from '@/shared/hooks/useApiMutation';
import {
  ICustomerCurrencies,
  IDynamicFiltersRequestBody,
  IFundingFiltersResponse,
  IUnifiedDynamicFilters,
} from './filters.types';
import { apiRequest } from '@/services/api/api';
import { agenciesEnabled } from '@/shared/config/features';

export const useCustomerFiltersMutation = () => {
  const currenciesEndpoint = getFullEndpoint(
    'filters',
    API_ENDPOINTS.CUSTOMER_CURRENCIES,
  );

  const sourcesEndpoint = getFullEndpoint(
    'filters',
    API_ENDPOINTS.CUSTOMER_FILTER_SOURCES,
  );

  return useApiMutation<IUnifiedDynamicFilters, { customer_uuid: string }>(
    'get',
    currenciesEndpoint,
    true,
    undefined,
    {
      mutationFn: async ({ customer_uuid }) => {
        const [currenciesRes, fundingFiltersRes] = await Promise.all([
          apiRequest<ICustomerCurrencies, IDynamicFiltersRequestBody>(
            'get',
            currenciesEndpoint,
            undefined,
            true,
            {
              pathParams: { customer_uuid },
            },
          ),
          apiRequest<IFundingFiltersResponse, IDynamicFiltersRequestBody>(
            'get',
            sourcesEndpoint,
            undefined,
            true,
            {
              pathParams: { customer_uuid },
            },
          ),
        ]);

        const fundingFilters = fundingFiltersRes.data;
        const unifiedFilters: IUnifiedDynamicFilters = {
          currencies: currenciesRes.data.currencies,
        };

        if (fundingFilters.sources?.length) {
          unifiedFilters.sources = fundingFilters.sources;
        }

        if (agenciesEnabled) {
          unifiedFilters.agencies = fundingFilters.agencies ?? [];
          unifiedFilters.invoice_agencies =
            fundingFilters.invoice_agencies ?? [];
        }

        unifiedFilters.commercial_terms_agencies =
          fundingFilters.commercial_terms_agencies ?? [];

        if (fundingFilters.networks?.length) {
          unifiedFilters.networks = fundingFilters.networks;
        }

        return unifiedFilters;
      },
    },
  );
};
